"use strict";
/**
 * The one piece of Plan arithmetic a client runs that isn't a plain sum or difference:
 * a % the user types, turned into dollars (S2). The server sends the dollars for every %
 * it shows (`pct_amounts`); this is only for a % typed in, and the engine uses the same
 * rule, so the two never disagree by a cent.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.planPctAmountCents = planPctAmountCents;
/** "15.00" → 1500: a PlanPct as hundredths of a percent, read exactly from its digits. */
function pctHundredths(pct) {
    const match = /^(-?)(\d+)(?:\.(\d{0,2}))?$/.exec(pct.trim());
    if (match === null)
        throw new Error(`not a PlanPct: ${pct}`);
    const [, sign, whole, frac = ""] = match;
    const value = Number(whole) * 100 + Number(frac.padEnd(2, "0"));
    return sign === "-" ? -value : value;
}
/** pct × left after bills, in cents, rounded half-up to the cent (half away from zero
 *  for a negative base). `planPctAmountCents("15.00", 171600)` is 25740 ($257.40). */
function planPctAmountCents(pct, leftAfterBillsCents) {
    const product = pctHundredths(pct) * leftAfterBillsCents; // cents × 10,000
    const rounded = Math.floor((Math.abs(product) + 5000) / 10000);
    return product < 0 ? -rounded : rounded;
}
//# sourceMappingURL=planMath.js.map